export default __webpack_public_path__ + "static/media/item6@2x.d249142b.png";